export const videoHasTags = (video = {}) => {
  const tagSources = [video?.tagsDetails, video?.tagsData, video?.tags];
  return tagSources.some(tags => Array.isArray(tags) && tags.length > 0);
}